import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import AstroGLImage from "../images/astrogl.svg"

export default function MarketingTrustedBy() {
	return (
		<div className="space-y-8">
			<h2 className="text-center text-gray-400 text-sm font-semibold uppercase tracking-wide">Trusted by</h2>
			<div className="max-w-lg mx-auto grid grid-cols-2 gap-4">
				<div className="col-span-2 flex justify-center md:col-span-1">
					<StaticImage src="../images/blinkist.png" alt="Blinkist" objectFit="contain" imgClassName="h-8" className="h-8" />
				</div>
				<div className="col-span-2 flex justify-center md:col-span-1">
					<AstroGLImage className="h-8" />
				</div>
			</div>
		</div>
	)
}
  